var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#8C92A4",
    clipPath: "url(#delete_icon_svg_clip)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.31 5.99H3.7a.35.35 0 00-.36.35v9.92a1.42 1.42 0 001.42 1.42h8.5a1.42 1.42 0 001.42-1.42V6.34A.35.35 0 0014.3 6zm-6.55 9.2a.53.53 0 11-1.06 0V8.83a.53.53 0 111.06 0v6.38zm3.54 0a.53.53 0 01-1.06 0V8.83a.53.53 0 111.06 0v6.38zM16.08 3.51h-3.36a.18.18 0 01-.18-.18v-.88A1.77 1.77 0 0010.77.68H7.23a1.77 1.77 0 00-1.77 1.77v.88a.18.18 0 01-.18.18H1.92a.7.7 0 000 1.42h14.16a.7.7 0 000-1.42zm-9.2-.18v-.88a.35.35 0 01.35-.36h3.54a.35.35 0 01.35.36v.88a.18.18 0 01-.17.18h-3.9a.18.18 0 01-.18-.18z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "delete_icon_svg_clip"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5.68h17v17H.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.a8afcc6a0463c66cd152bd3569d35ad6.svg";
export { ForwardRef as ReactComponent };